<script>
import headers from "@/components/headers";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      carregando: false,
      headers: headers,
      registros: [],
      midias: [],
      motivos: [],
      motivo: null,
      novoMotivo: null,
      midia: null,
      novaMidia: null,
      resultado: null,
      novoResultado: null,
      datahora: null,
      registro: null,
      showTimeline: true,
      submitting: false,
    };
  },
  mounted() {
    this.getRegistros()
    this.getMotivos()
    this.getMidias()
    this.getResultados()
    this.datahora = this.getDatahora()
  },
  methods: 
  {
    showForm()
    {
      this.showTimeline = false
      this.datahora = this.getDatahora()
    },
    getDatahora()
    {
      let date = new Date()
      let ano = date.getFullYear()
      let mes = ('0' + (date.getMonth()+1)).slice(-2)
      let dia = ('0' + date.getDate()).slice(-2)
      let hora = date.toLocaleTimeString()
      return ano + '-' + mes + '-' + dia + 'T' + hora
    },
    getRegistros()
    {
      this.carregando = true
      this.$axios
      .get(process.env.VUE_APP_API_URL + "/api/aluno/registro_contato", 
        {
          headers: headers,
          params: {
            codPessoa: this.aluno.codPessoa
          }
        }
      )
      .then((response) => {
        this.registros = response.data
      })
      .catch((error) => {
        this.$axiosCatch(error)
      })
      .finally(() => {
        this.carregando = false
      })
    },
    getMotivos()
    {
      this.$axios
      .get(process.env.VUE_APP_API_URL + "/api/aluno/registro_contato/motivos", 
        {
          headers: headers,
        }
      )
      .then((response) => {
        this.motivos = response.data
      })
      .catch((error) => {
        this.$axiosCatch(error)
      })
      .finally(() => {
      })
    },
    getMidias()
    {
      this.$axios
      .get(process.env.VUE_APP_API_URL + "/api/aluno/registro_contato/midias", 
        {
          headers: headers,
        }
      )
      .then((response) => {
        this.midias = response.data
      })
      .catch((error) => {
        this.$axiosCatch(error)
      })
      .finally(() => {
      })
    },
    getResultados()
    {
      this.$axios
      .get(process.env.VUE_APP_API_URL + "/api/aluno/registro_contato/resultados", 
        {
          headers: headers,
        }
      )
      .then((response) => {
        this.resultados = response.data
      })
      .catch((error) => {
        this.$axiosCatch(error)
      })
      .finally(() => {
      })
    },
    salvarRegistro()
    {
      this.submitting = true
      let payload = {
        motivo: (this.motivo === '' ? this.novoMotivo : this.motivo),
        midia: (this.midia === '' ? this.novaMidia : this.midia),
        resultado: (this.resultado === '' ? this.novoResultado : this.resultado),
        datahora: this.datahora,
        registro: this.registro,
        codPessoa: this.aluno.codPessoa,
      }
      this.$axios
      .post(
        process.env.VUE_APP_API_URL + "/api/aluno/registro_contato",
        payload,
        {
          headers: headers
        }
      )
      .then((response) => {
        Swal.fire("Registro salvo!", "O novo registro foi criado.", "success");
        this.getRegistros()
        this.getMotivos()
        this.getMidias()
        this.getResultados()
        this.midia = null
        this.motivo = null
        this.resultado = null
        this.novoMotivo = null
        this.novaMidia = null
        this.novoResultado = null
        this.registro = null
        this.datahora = this.getDatahora()
        this.showTimeline = true
        return response
      })
      .catch((error) => {
        this.$axiosCatch(error)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  },
  props: 
  {
    aluno: {
      type: Object
    }
  },
};
</script>
<template>
  <div class="row" v-if="!aluno">
      <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-danger">
        <i class="mdi mdi-block-helper me-2"></i>
        Nenhum aluno foi selecionado. Primeiro busque um aluno e depois volte aqui para visualizar suas informações.
      </div>
      <router-link to="/aluno/buscar">
        <button type="button" class="btn btn-primary">
          <i class="bx bx-user font-size-16 align-middle me-2"></i> 
          Buscar aluno
        </button>
      </router-link>
    </div>
    <div v-else>
      <div v-if="showTimeline">
        <div class="button-items">
          <button type="button" class="btn btn-primary" @click="showForm">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Novo registro
          </button>
        </div>
        <br />
        <ul class="verti-timeline list-unstyled" v-if="registros.length > 0">
          <li
            class="event-list"
            v-for="(registro, id) of registros"
            :key="id"
          >
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{ registro.datahora }}
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <table>
                  <tr>
                    <td><strong>Contato feito por:</strong></td>
                    <td>{{ registro.nome }} {{ registro.sobrenome }}</td>
                  </tr>
                  <tr>
                    <td><strong>Mídia:</strong></td>
                    <td>{{ registro.midia }}</td>
                  </tr>
                  <tr>
                    <td><strong>Motivo:</strong></td>
                    <td>{{ registro.motivo }}</td>
                  </tr>
                  <tr>
                    <td><strong>Resultado:</strong></td>
                    <td>{{ registro.resultado }}</td>
                  </tr>
                  <tr>
                    <td><strong>Registro:</strong></td>
                    <td>{{ registro.registro }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </li>
        </ul>
        <div v-else-if="carregando">
          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Buscando registros de contato...
        </div>
        <div v-else role="danger" aria-live="polite" aria-atomic="true" class="alert alert-warning">
          Nenhum registro encontrado.
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12">
            <form class="form-horizontal" role="form" v-on:submit.prevent="salvarRegistro">

              <div class="row">
                <div class="mb-3 col-lg-3">
                  <label>Telefone 1</label>
                  <input
                    readonly
                    type="text"
                    :value="aluno.telefone1"
                    class="form-control"
                  />
                </div>
                <div class="mb-3 col-lg-3">
                  <label>Telefone 2</label>
                  <input
                    readonly
                    type="text"
                    :value="aluno.telefone2"
                    class="form-control"
                  />
                </div>
                <div class="mb-3 col-lg-3">
                  <label>Telefone 3</label>
                  <input
                    readonly
                    type="text"
                    :value="aluno.telefone3"
                    class="form-control"
                  />
                </div>
                <div class="mb-3 col-lg-3">
                  <label>E-mail</label>
                  <input
                    readonly
                    type="text"
                    :value="aluno.email"
                    class="form-control"
                  />
                </div>
              </div>

            

              <div class="mb-2 row">
                <label class="col-md-2 col-form-label">
                  Data e hora
                </label>
                <div class="col-md-10">
                  <input 
                    class="form-control" 
                    v-model="datahora"
                    type="datetime-local"
                  />
                </div>
              </div>

              <div class="mb-2 row">
                <label class="col-md-2 col-form-label">
                  Mídia de contato
                </label>
                <div class="col-md-10">
                  <select class="form-control" v-model="midia">
                    <option :value="null" disabled>Selecione a mídia usada para contato</option>
                    <option v-for="(midia,i) in midias" :key="i" v-bind:value="midia">{{ midia }}</option>
                    <option :value="''">+ Criar novo</option>
                  </select>
                </div>
              </div>

              <div class="mb-2 row" v-show="midia === ''">
                <label class="col-md-2 col-form-label">
                  Nova mídia de contato
                </label>
                <div class="col-md-10">
                  <input class="form-control" v-model="novaMidia"/>
                </div>
              </div>

              <div class="mb-2 row">
                <label class="col-md-2 col-form-label">
                  Motivo do contato
                </label>
                <div class="col-md-10">
                  <select class="form-control" v-model="motivo">
                    <option :value="null" disabled>Selecione o motivo do contato</option>
                    <option v-for="(motivo,i) in motivos" :key="i" v-bind:value="motivo">{{ motivo }}</option>
                    <option :value="''">+ Criar novo</option>
                  </select>
                </div>
              </div>

              <div class="mb-2 row" v-show="motivo === ''">
                <label class="col-md-2 col-form-label">
                  Novo motivo de contato
                </label>
                <div class="col-md-10">
                  <input class="form-control" v-model="novoMotivo"/>
                </div>
              </div>

              <div class="mb-2 row">
                <label class="col-md-2 col-form-label">
                  Resultado do contato
                </label>
                <div class="col-md-10">
                  <select class="form-control" v-model="resultado">
                    <option :value="null" disabled>Selecione o resultado do contato</option>
                    <option v-for="(resultado,i) in resultados" :key="i" v-bind:value="resultado">{{ resultado }}</option>
                    <option :value="''">+ Criar novo</option>
                  </select>
                </div>
              </div>

              <div class="mb-2 row" v-show="resultado === ''">
                <label class="col-md-2 col-form-label">
                  Novo resultado de contato
                </label>
                <div class="col-md-10">
                  <input class="form-control" v-model="novoResultado"/>
                </div>
              </div>

              <div class="mb-2 row">
                <label class="col-md-2 col-form-label">
                  Registro do contato
                </label>
                <div class="col-md-10">
                  <textarea class="form-control" v-model="registro" rows="5"/>
                </div>
              </div>

            </form>
          </div>
        </div>
        <div class="button-items">
          <button type="button" class="btn btn-secondary" @click="showTimeline = true">
            <i class="bx bx-left-arrow-alt font-size-16 align-middle me-2"></i>
            Voltar para os registros
          </button>
          <button type="submit" class="btn btn-success" v-if="submitting">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Salvar
          </button>
          <button type="button" class="btn btn-success" @click="salvarRegistro" v-else>
            <i class="bx bx-save font-size-16 align-middle me-2"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>
</template>